// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Pause: React.FC = () => {
    return<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 12 13" enableBackground="new 0 0 12 13" xmlSpace="preserve">
<path fill="currentColor" d="M11.5,12.5H7.64v-12h3.86V12.5z M8.64,11.5h1.86v-10H8.64V11.5z M4.36,12.5H0.5v-12h3.86V12.5z M1.5,11.5h1.86v-10H1.5V11.5
   z"/>
</svg>;
};

export default React.memo(Pause);